import getApiClient from '@/plugins/api'

export default {
  changePage: function (page) {
    this.page = page
  },

  loadTransfers() {
    const self = this;
    const api = getApiClient(self.$root.$store);

    self.$store.commit('startLoading')

    self.searchParams.page = self.page
    self.searchParams.itemsPerPage = self.perPage

    api.get('pagarme_transfers', {
      params: self.searchParams
    })
      .then((result) => {
        self.transfers = result.data['hydra:member']
        self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  openTransferDetails: function(transfer) {
    this.transferDetails = transfer
    this.showTransferDetails = true
  }
}
